var exports = {
  "factoid": "xdde3148b--8a0cd5--factoid",
  "content": "xdde3148b--8a0cd5--content",
  "factoid--area": "xdde3148b--8a0cd5--factoid--area",
  "factoid--floor": "xdde3148b--8a0cd5--factoid--floor",
  "factoid--construction-time": "xdde3148b--8a0cd5--factoid--construction-time",
};

module.exports = exports;
